"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectorType = exports.numberSelector = exports.booleanSelector = void 0;
var config_1 = require("@smithy/core/config");
Object.defineProperty(exports, "booleanSelector", { enumerable: true, get: function () { return config_1.booleanSelector; } });
Object.defineProperty(exports, "numberSelector", { enumerable: true, get: function () { return config_1.numberSelector; } });
Object.defineProperty(exports, "SelectorType", { enumerable: true, get: function () { return config_1.SelectorType; } });
